import angular from 'angular';

import EmailVerificationRequestComponent from './email-verification-request.cmpt';

export default angular
    .module('application.scene.identity.scene.email-verification.request', [])
    .component(EmailVerificationRequestComponent.selector, EmailVerificationRequestComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.email-verification.request', {
        url: '/re-send',
        component: EmailVerificationRequestComponent.selector,
        params: {
            email: null,
            error: null
        },
        resolve: {
            email: emailResolve,
            error: errorResolve
        }
    });
}

/* @ngInject */
function emailResolve($transition$) {
    let params = $transition$.params() || {};
    return params.email || null;
}

/* @ngInject */
function errorResolve($transition$) {
    let params = $transition$.params() || {};
    return params.error || null;
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/email-verification/scene/email-verification-request/index.js